import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateAudioRecorderFormField(
  params: FormFieldGenerationParams<'audioRecorder'>,
): PartialPropsOf<'audioRecorder'> {
  const props: PartialPropsOf<'audioRecorder'> = applyPropsPatch(params.props, {
    content: { title: { enabled: true } },
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  return props;
}
